// work data

export const Work = [
    {
        id:1,
        name:"MERN-Stack Chat Application",
        description:"It has a Real-time chat functionality using socket.io.I have also integrated jwtwebtokens for authoruzation and password hashing for security purpose.",
        tags:["React","Node-Js","Express-Js","MongoDB","Cloudinary"],
        
        demo:"https://chat-always.herokuapp.com",
        github:"https://github.com/adarsh4567/Mern-Stack-Chat-App"
    },
    {
        id:2,
        name:"Movies Website",
        description:"It provides all types of movies at one place in different sections using MoviesDb Api",
        tags:["react","Material-ui"],
        
        demo:"https://adarsh4567.github.io/Entertainment",
        github:"https://github.com/adarsh4567/Entertainment"
        
    },
    {
        id:3,
        name:"Crypto-Tracking Application",
        description:"It shows all different types of Crypto-currencies at one place.",
        tags:["react","api","Material-Ui"],
        
        demo:"https://adarsh4567.github.io/Crypto-Zone/",
        github:"https://github.com/adarsh4567/Crypto-Zone"
    },
    {
        id:3,
        name:"Next Js Travel Website",
        description:"It shows all different types of Property and Resorts at one place.",
        tags:["Next JS","Rapid-api","Chakra-Ui"],
        
        demo:"https://travel-app-rosy.vercel.app",
        github:"https://github.com/adarsh4567/TravelApp"
    },
    
    
  
] 